import { DatePipe, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NbButtonModule, NbDialogService } from '@nebular/theme';
import { BehaviorSubject } from 'rxjs';
import { WebSocketResults } from 'src/app/core/services/web-socket.service';
import { InsightTerminateModalComponent } from '../insight-terminate-modal/insight-terminate-modal.component';

@Component({
  selector: 'app-insight-websocket-window',
  templateUrl: './insight-websocket-window.component.html',
  styleUrls: ['./insight-websocket-window.component.scss'],
  imports: [NgIf, DatePipe, NbButtonModule]
})
export class InsightWebsocketWindowComponent implements OnInit {
  @Input() results$!: BehaviorSubject<WebSocketResults>;

  public results?: WebSocketResults;
  public insight_id?: number;

  constructor(private dialogService: NbDialogService) {}

  public ngOnInit() {
    this.results$.subscribe((data) => (this.results = data));
  }

  public stop() {
    this.dialogService.open(InsightTerminateModalComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: { insight_id: this.insight_id, batch_job_id: this.results?.job_id }
    });
  }
}
